import { render, staticRenderFns } from "./common-nav-box.vue?vue&type=template&id=714c7ef6&scoped=true"
import script from "./common-nav-box.vue?vue&type=script&lang=js"
export * from "./common-nav-box.vue?vue&type=script&lang=js"
import style0 from "./common-nav-box.vue?vue&type=style&index=0&id=714c7ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c7ef6",
  null
  
)

export default component.exports